const translations = {
  "en": {
    "Rating down": "Rating down",
    "Rating up": "Rating up"
  },
  "zh-tw": {
    "Rating down": "評分下降",
    "Rating up": "評分上升"
  }
};

export default translations;
